import React from "react";
import mobileApp from '../../../Asset/mobile-app.png';

const MobileAppFeature = ({ onOpenMembershipModal }) => {

  return (
    <div className="mobile-app-feature-content flex flex-col-reverse md:flex-row bg-[rgba(242,242,242,1)] pt-12 ">

      {/* Left Side mobile app feature image */}
      <div className="mobile-app-feature-content-left  flex justify-center items-center text-[var(--gray-black)] w-full md:w-[55%] xl:w-[53%]  md:pl-3">

        <div className="mobile-app-feature-content-left-inner-container flex flex-col items-start   w-[85%] ">
          {/* Heading part */}
          <div className="mobile-app-feature-content-left-header  md:text-[3.5rem] text-[2.25rem] font-ClashGrotesk font-medium  leading-tight md:text-left text-center mb-6 md:mb-12">
            <p className=" md:text-left text-center ">Explore Membership Packages – Exclusively on Our Mobile App</p>


          </div>

          {/* Description and buttons */}
          <div className="flex flex-col md:items-start items-center">
            <p className="mobile-app-feature-content-left-description text-base md:text-xl font-manrope font-[470] text-center md:text-left mb-7 text-[#464646]">
              We are gearing up to launch membership packages that'll pair you up for different sports, include coaching sessions, social mixers, and a gamified way to dive into our community. Stay tuned—you won't want to miss out.
            </p>
            <div className="flex flex-col md:flex-row gap-4 w-full md:w-auto">
              <button onClick={onOpenMembershipModal} className="mobile-app-feature-content-left-btn text-base md:text-lg whitespace-nowrap bg-[var(--purple-blue)] md:py-4 py-3 px-8 md:px-10 text-[var(--white)] rounded-lg font-manrope font-semibold">
                Join membership waitlist
              </button>
              <button className="mobile-app-feature-content-left-btn hidden md:block text-base md:text-lg whitespace-nowrap md:py-4 py-3 px-15 md:px-20 text-[var(--white)] rounded-lg font-manrope font-semibold" style={{ backgroundColor: 'rgba(140, 89, 237, 0.63)' }}>
                Read More
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Right Side mobile app feature image */}

      <div className="mobile-app-feature-content-right mb-12 md:mb-0  flex justify-center items-center w-full md:w-[45%] xl:w-[48%] ">
        <img src={mobileApp} alt="Mobile Application" className="mobile-app-img lg:w-[85%]" />
      </div>

    </div>
  );
};

export default MobileAppFeature;